// extracted by mini-css-extract-plugin
export default {"title":"SeatingPlanScreen_title__s2mM0","mainDiv":"SeatingPlanScreen_mainDiv__7fNca"};